/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import produce from "immer";
import AllReports from "./AllReports";

const LocationsList = () => {
  const [selectedTab, setSelectedTab] = useState("locations");
  const [checkedItems, setCheckedItems] = useState([]);
  const history = useHistory();
  const { tab } = useParams();

  useEffect(() => {
    if (typeof tab === "undefined") setSelectedTab("locations");
    else setSelectedTab(tab);
  }, [tab]);

  const classNameTab = (pos) => {
    if (pos === selectedTab) return "tabActive";
    else return "";
  };
  return (
    <div id="index" className="containerFlex maxHd">
      <div className="contentArea">
        <nav className="tabs" id="report-navigation">
          <a
            href="#"
            className={classNameTab("locations")}
            style={{ marginRight: "80%" }}
            onClick={(e) => {
              e.preventDefault();
              setSelectedTab("locations");
              history.push("/locations3");
            }}
          >
            <span className="tab-text">Locations</span>
          </a>
        </nav>

        <div className="tabContent">
          <AllReports activeTab={selectedTab} setCheckedItems={setCheckedItems} checkedItems={checkedItems} />
        </div>
      </div>
    </div>
  );
};

export default LocationsList;
